import { render, staticRenderFns } from "./ButtonAddPhase.vue?vue&type=template&id=73cd1646&scoped=true&"
import script from "./ButtonAddPhase.vue?vue&type=script&lang=js&"
export * from "./ButtonAddPhase.vue?vue&type=script&lang=js&"
import style1 from "./ButtonAddPhase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd1646",
  null
  
)

export default component.exports